import { Section } from "types/Models/Filing";
import classNames from "classnames";
import { useRoleBasedView } from "hooks/useRoleBasedView"; // Ensure AllFields is imported
import { AllFields } from "./step0";
import { FormTooltip } from "./formControl";
import { Task } from "types/Models/task";

export const FormSections = ({
  section,
  isPricingStep,
  updatedTask,
  formId,
  updateSectionKeyIdPair,
  updateRemovedSectionIds,
  current,
  data,
  uuid,
  groupId,
  isArchived,
  entityId,
  formData,
  task,
  quarter,
  activeSectionKey,
  lightDescription,
}: {
  section: Section;
  isPricingStep: boolean;
  updatedTask: any;
  formId: string;
  updateSectionKeyIdPair: (args: { key: string; id: number }) => void;
  updateRemovedSectionIds: (args: { key: string; id: number }) => void;
  current: any;
  data: any;
  uuid: string;
  groupId: string;
  isArchived: boolean;
  entityId: string;
  formData: any;
  task: Task;
  quarter?: number;
  activeSectionKey: string;
  lightDescription?: boolean;
}) => {
  const { isAdmin } = useRoleBasedView();
  const isActive = activeSectionKey === section.section_key;

  return (
    <div
      id={section.section_key}
      key={section?.section_title}
      className={classNames(
        "t-pb-36 t-border t-border-b-0 t-border-r-0 t-border-t-0 t-border-solid t-border-l-neutral-10",
        {
          "t-pointer-events-none": isPricingStep && !isAdmin,
        }
      )}
    >
      <div className="t-relative t-pl-7 t-pb-0.5">
        <div
          className={classNames("t-absolute -t-left-px t-top-0 t-h-5 t-w-0.5", {
            "t-bg-purple-50": isActive,
            "t-bg-neutral-50": !isActive,
          })}
        />
        <div className="t-text-text-100 t-text-subtext-lg">
          {section?.section_title}{" "}
          {section?.tooltip && <FormTooltip tooltipText={section.tooltip} />}
        </div>
      </div>
      <div className="t-ml-5">
        <AllFields
          updatedTask={updatedTask}
          formId={formId}
          section={section}
          updateSectionKeyIdPair={updateSectionKeyIdPair}
          updateRemovedSectionIds={updateRemovedSectionIds}
          current={current}
          data={data}
          uuid={uuid}
          groupId={groupId}
          isArchived={isArchived}
          entityId={entityId}
          formData={formData}
          deadline={task.deadline}
          season={task.season}
          quarter={quarter}
          entityName={task?.entity?.name}
          lightDescription={lightDescription}
        />
      </div>
    </div>
  );
};
